import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { STR } from "@/data/i18n";
import { useLang } from "@/lib/lang";
import { SectionHeading } from "./Shared";

const FAQS_ID = [
    {
        q: "Apakah harga paket sudah termasuk domain dan hosting?",
        a: "Belum. Harga paket adalah biaya pembuatan website. Domain, hosting, dan biaya payment gateway dibayarkan terpisah sesuai penyedia masing-masing. Jangan khawatir, kami akan membantu mengurus semuanya sampai beres.",
    },
    {
        q: "Berapa lama pengerjaan website?",
        a: "Lama pengerjaan tergantung paket yang dipilih dan kelengkapan materi (foto, harga, deskripsi). Estimasi waktu yang jelas akan kami sampaikan setelah diskusi awal, dan Anda akan diinformasikan di setiap tahap pengerjaan.",
    },
    {
        q: "Apakah bisa sinkron dengan Traveloka, Airbnb, atau Booking.com?",
        a: "Sinkronisasi kalender tersedia di Paket Luxury selama platform tersebut mendukung (misalnya lewat kalender iCal). Ketersediaannya mengikuti kebijakan masing-masing platform, dan akan kami cek bersama sebelum proyek dimulai.",
    },
    {
        q: "Bagaimana cara pembayarannya?",
        a: "Pembayaran dilakukan bertahap: booking fee Rp 500.000 untuk mengunci jadwal, DP 50% (sudah termasuk booking fee) sebelum pengerjaan, dan pelunasan 50% sebelum serah terima. Detail rekening dan invoice dibagikan resmi saat kesepakatan.",
    },
    {
        q: "Apakah ada layanan perawatan bulanan?",
        a: "Ada, sifatnya opsional. Layanan perawatan mencakup pembaruan konten ringan, pengecekan keamanan, dan backup berkala. Biayanya fleksibel dan bisa dibahas sesuai kebutuhan properti Anda.",
    },
];

export const Faq = () => {
    const { lang } = useLang();
    const t = STR.faq[lang];
    const items = lang === "en" ? STR.faq.en.items : FAQS_ID;

    return (
        <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
            <div className="mx-auto max-w-3xl px-5 md:px-8">
                <SectionHeading eyebrow={t.eyebrow} title={t.title} subtitle={t.subtitle} />
                <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                    {items.map((item, i) => (
                        <AccordionItem key={item.q} value={`faq-${i}`} className="border-b border-white/10">
                            <AccordionTrigger
                                data-testid={`faq-question-${i + 1}`}
                                className="py-6 text-left text-base font-semibold text-slate-100 transition-colors duration-200 hover:text-amber-400 hover:no-underline"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-answer-${i + 1}`}
                                className="pb-6 text-sm leading-relaxed text-zinc-400"
                            >
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};
